import { render, staticRenderFns } from "./Evaluaciones.vue?vue&type=template&id=0075b89e&"
import script from "./Evaluaciones.vue?vue&type=script&lang=js&"
export * from "./Evaluaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports